<div #chart class="max-width-graph"></div>
